<div class="analyst-description" [class.expanded]="isExpanded">
    <quill-editor
        [ngModel]="content"
        (onContentChanged)="onContentChange($event.html)"
        [modules]="quillModules"
        [beforeRender]="beforeRender"
        (onEditorCreated)="onEditorCreated($event)"
        placeholder="Describe this transformer..."
        theme="snow">
        <div quill-editor-toolbar>
            <span class="ql-formats">
                <button class="ql-bold" title="Bold"></button>
                <button class="ql-italic" title="Italic"></button>
                <button class="ql-underline" title="Underline"></button>
            </span>
            <span class="ql-formats">
                <button type="button" class="app-ql-custom" title="Insert timestamp and current user" (click)="insertTimestamp()">
                    <span class="material-icons">schedule</span>
                </button>
            </span>
            <span class="ql-formats">
                <button type="button" class="app-ql-custom" title="Undo" (click)="undo()">
                    <span class="material-icons">undo</span>
                </button>
                <button type="button" class="app-ql-custom" title="Redo" (click)="redo()">
                    <span class="material-icons">redo</span>
                </button>
            </span>
            <span class="ql-formats">
                <select class="ql-size" title="Font Size">
                    <option value="small"></option>
                    <option selected></option>
                    <option value="large"></option>
                    <option value="huge"></option>
                </select>
                <select class="ql-color" title="Font Color">
                    <!-- 13x4 palette curated for a dark editor background, grouped by hue (one
                         family per column) rather than by lightness — adjacent swatches are
                         always the same hue. Families left-to-right: grey (from white), yellow,
                         amber, orange, red, pink, purple, indigo, blue, sky, teal, green,
                         yellow-green (hue 72°, closing the wheel back toward yellow at 54°).
                         Quill's own default (7x5) had its whole last row in near-black shades
                         unreadable against this app's dark theme, and too few distinct hues.
                         Each column runs a genuine 4-tier progression (not a uniform tint of one
                         base color, which just produced 48 pastels): light pastel (S45/L88) ->
                         medium pastel (S60/L78) -> semi-bold (S68/L72) -> full bold, i.e. the pure,
                         fully-saturated hue (S100/L50 — literally 100% blue, 100% green, etc).
                         Semi-bold sits close to medium pastel, leaving the big jump in saturation
                         to the final step into full bold. -->
                    <!-- Row 1: light pastel -->
                    <option value="#ffffff"></option>
                    <option value="#eeebd3"></option>
                    <option value="#eee4d3"></option>
                    <option value="#eeded3"></option>
                    <option value="#eed3d3"></option>
                    <option value="#eed3e0"></option>
                    <option value="#ead3ee"></option>
                    <option value="#dad3ee"></option>
                    <option value="#d3e0ee"></option>
                    <option value="#d3e7ee"></option>
                    <option value="#d3eeec"></option>
                    <option value="#d3eed5"></option>
                    <option value="#e9eed3"></option>
                    <!-- Row 2: medium pastel -->
                    <option value="#e0e0e0"></option>
                    <option value="#e9e2a5"></option>
                    <option value="#e9d0a5"></option>
                    <option value="#e9c1a5"></option>
                    <option value="#e9a5a5"></option>
                    <option value="#e9a5c7"></option>
                    <option value="#dda5e9"></option>
                    <option value="#b6a5e9"></option>
                    <option value="#a5c7e9"></option>
                    <option value="#a5d8e9"></option>
                    <option value="#a5e9e3"></option>
                    <option value="#a5e9ab"></option>
                    <option value="#dbe9a5"></option>
                    <!-- Row 3: semi-bold -->
                    <option value="#b8b8b8"></option>
                    <option value="#e8de87"></option>
                    <option value="#e8c587"></option>
                    <option value="#e8b087"></option>
                    <option value="#e88787"></option>
                    <option value="#e887b8"></option>
                    <option value="#d887e8"></option>
                    <option value="#9f87e8"></option>
                    <option value="#87b8e8"></option>
                    <option value="#87d0e8"></option>
                    <option value="#87e8e0"></option>
                    <option value="#87e88f"></option>
                    <option value="#d5e887"></option>
                    <!-- Row 4: full bold — pure, fully-saturated hue -->
                    <option value="#757575"></option>
                    <option value="#ffe500"></option>
                    <option value="#ffa200"></option>
                    <option value="#ff6a00"></option>
                    <option value="#ff0000"></option>
                    <option value="#ff0080"></option>
                    <option value="#d400ff"></option>
                    <option value="#4000ff"></option>
                    <option value="#007fff"></option>
                    <option value="#00bfff"></option>
                    <option value="#00ffea"></option>
                    <option value="#00ff15"></option>
                    <option value="#ccff00"></option>
                </select>
            </span>
            <span class="ql-formats">
                <button class="ql-list" value="ordered" title="Numbered List"></button>
                <button class="ql-list" value="bullet" title="Bulleted List"></button>
            </span>
            <span class="ql-formats">
                <button class="ql-link" title="Insert Link"></button>
                <button class="ql-code-block" title="Code Block"></button>
            </span>
            <span class="ql-formats">
                <button class="ql-clean" title="Clear Formatting"></button>
            </span>
            <span class="ql-formats">
                <button type="button" class="app-ql-custom" [title]="isExpanded ? 'Collapse' : 'Expand'" (click)="toggleExpand()">
                    <span class="material-icons">{{ isExpanded ? 'close_fullscreen' : 'open_in_full' }}</span>
                </button>
            </span>
        </div>
    </quill-editor>
</div>
